import React from 'react'
import ComingSoon from '../../singles/coming-soon/Coming-soon'
export default function About() {
  return (
    <div>
        <ComingSoon />
    </div>
  )
}
